import React from 'react';
import { useWindowSize } from '@yme/hooks/index';
import { Skeleton } from '..';
export function GallerySkeleton({ aspectRatio }) {
    const { isInfiniteDesktopView } = useWindowSize();
    return (React.createElement(React.Fragment, null,
        React.createElement(Skeleton, { skeletonProps: {
                width: '100%',
                style: {
                    aspectRatio,
                },
            }, wrapperProps: {
                mbL: 24,
                mbS: 16,
            } }),
        isInfiniteDesktopView ? (React.createElement(Skeleton, { skeletonProps: {
                width: 84,
                height: 48,
                count: 4,
                style: {
                    marginRight: '16px',
                },
                inline: true,
            } })) : (React.createElement(Skeleton, { skeletonProps: {
                width: 100,
                height: 6,
                style: {
                    display: 'block',
                    margin: '0 auto',
                },
            } }))));
}
